import React from "react";
import { SettingsRow } from "../SettingsRow";
import { KeyLinks } from "./KeyLinks";
import { SocialLinks } from "./SocialLinks";
import { useDesktopMediaQuery } from "hooks";
import styled from "styled-components";
import { Divider } from "../AdvancedSettings/Fields";
export const ArtistLinks: React.FC = () => {
  const isDesktop = useDesktopMediaQuery();

  return (
    <SettingsRow
      title={"Artist Links"}
      description={
        <>
          Artist links are visible across SET. services and may be seen by the
          general public when publishing content.
        </>
      }
    >
      <Container>
        <Column>
          <KeyLinks />
        </Column>
        {isDesktop && <StyledDivider />}
        <Column>
          <SocialLinks />
        </Column>
      </Container>
    </SettingsRow>
  );
};

const Container = styled.div`
  display: flex;
  margin-bottom: 15px;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    gap: 20px;
  }
`;

const StyledDivider = styled(Divider)`
  margin-top: 15px;
`;

const Column = styled.div`
  width: 250px;

  ${({ theme }) => theme.media.tablet} {
    width: 200px;
  }

  ${({ theme }) => theme.media.mobile} {
    width: 100%;
  }
`;
